unable to read source [project]/node_modules/src/ui/scanner/scan-type-selector.ts